import React from "react";
import { QueryObserverResult } from "react-query";
import {
  MigrationSetImport,
  MigrationSetWithImports,
} from "../../shared";
import { Card, CardIconWrapper } from "../card";
import { getRegionSpecificExpenseHeader } from "../../shared/utils/constants";
import {
  getUnbilledExpensesDescription,
  getTemplateKey,
} from "../../functions/workflowFunctions";
import { CardDescription } from "../cardDescription";
import { UnbilledExpensesSVG, UnbilledExpensesUKSVG } from "../../icons";

interface CardUnbilledExpenseProps {
  currentMigrationSetId: number;
  data: { imports: MigrationSetImport[] } | undefined;
  cardsState: Record<string, any>;
  disableButtonAccess: boolean;
  refetchMigrationSet: () => Promise<
    QueryObserverResult<MigrationSetWithImports, unknown>
  >;
  region: string;
}

export const CardUnbilledExpense: React.FC<CardUnbilledExpenseProps> = ({
  currentMigrationSetId,
  data,
  cardsState,
  disableButtonAccess,
  refetchMigrationSet,
  region,
}) => {
  const unbilledExpenseImport = data?.imports.find((i) => i.importType === "unbilledExpense");

  return (
    <Card
      image={
        region === "GB" ? (
          <CardIconWrapper>
            <UnbilledExpensesUKSVG />
          </CardIconWrapper>
        ) : (
          <CardIconWrapper>
            <UnbilledExpensesSVG />
          </CardIconWrapper>
        )
      }
      importType="unbilledExpense"
      templateKey={getTemplateKey("unbilledExpense", region)}
      fileName="unbilledExpense.csv"
      migrationSetId={currentMigrationSetId}
      migrationSetImport={data?.imports.find(
        (i) => i.importType === "unbilledExpense",
      )}
      headerText={getRegionSpecificExpenseHeader(region)}
      description={
        <CardDescription
          {...getUnbilledExpensesDescription(region, unbilledExpenseImport)}
          displayWiderColumn={true} // Pass the displayWiderColumn flag prop as true for all unbilled expenses
        />
      }
      cardState={cardsState["unbilledExpense"]}
      disableButtonAccess={disableButtonAccess}
      refetchMigrationSet={refetchMigrationSet}
      region={region}
    />
  );
};
